import React from "react";
import FilePage from "../FilePage/FilePage";

class DebitCreditListAttachment extends React.Component {
  render() {
    const { carContract } = this.props;

    return (
      <FilePage
        table={"car_contract"}
        id={carContract.id}
        title={"ضمیمه های معامله ماشین # " + carContract.id}
        handleBack={this.props.handleBack}
      />
    );
  }
}

export default DebitCreditListAttachment;
